import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
// import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, of } from 'rxjs'; // this created errors ats use below
// import {Observable} from 'rxjs/Rx';


import {UploadDocxTemplateModalComponent} from './../upload-docx-template-modal/upload-docx-template-modal.component';
import {UploadEmailTemplateModalComponent} from './../upload-email-template-modal/upload-email-template-modal.component';

import {UploadDotTemplateModalComponent} from './../upload-dot-template-modal/upload-dot-template-modal.component';


import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';
import {SubjectTemplateDocs} from '../../../shared/models/subjectTemplateDocsModel.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToolbarService, LinkService, ImageService, HtmlEditorService, FileManagerService, TableService, InsertHtml } from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection
} from '@syncfusion/ej2-angular-richtexteditor';
import { UploadDocxThemeTemplateComponent } from '../upload-docx-theme-template/upload-docx-theme-template.component';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { WooPromotionVariableModalComponent } from '../../system-variables/woo-promotion-variable-modal/woo-promotion-variable-modal.component';

@Component({
  selector: 'app-subject-com-type-template-doc-edit',
  templateUrl: './subject-com-type-template-doc-edit.component.html',
  styleUrls: ['./subject-com-type-template-doc-edit.component.css'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService,]
})
// EmojiPickerService, VideoService, AudioService, FormatPainterService
export class SubjectComTypeTemplateDocEditComponent implements OnInit {
  nav: any;
  doc_id: number;
  model: SubjectTemplateDocs;
  subject_template_doc: any;

  @ViewChild('defaultRTE', {static: false}) defaultRTE;
  @ViewChild('defaultRTE_b', {static: false}) defaultRTE_b;

  @ViewChild('noteTemplateEditor', {static: false}) noteTemplateEditor;
  @ViewChild('emailTemplateEditor', {static: false}) emailTemplateEditor;
  @ViewChild('noteTemplateEditorPrivate', {static: false}) noteTemplateEditorPrivate;
  @ViewChild('emailTemplateEditorPrivate', {static: false}) emailTemplateEditorPrivate;
  @ViewChild('emailSignatureTemplate', {static: false}) emailSignatureTemplate;
  
  public baseUploadURL: any;
  @ViewChild('brandForm') form: any; // the name of the form to access.
  @Input('brandForm') brandForm: any;
  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  stripped: any;
  filenameselected: any;
  brand_types: any;
  baseUploadURLEmailTemplates: string;
  subject_com_types: any;
  sent_subject_com_type_id: any;

  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: any;

  get_name: any;
  baseUploadURLOriginalWordTemplates: string;

  public myValue = 0;
  baseUploadURLDocxThemeTemplates: string;
  subjectAttemptType: any;
  subjectAttemptTypesList: any;

  isShow_email_editor = false;


  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton.bind(this),
      template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 

  public simpleToolBar_defaultRTE: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_defaultRTE.bind(this),
      template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };

 
  public simpleToolBar_noteTemplateEditor: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_noteTemplate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };   

  public simpleToolBar_noteTemplateEditorPrivate: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_noteTemplatePrivate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };       

  public simpleToolBar_emailTemplateEditor: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    {
      tooltipText: 'Insert Widget',
      undo: true,
      click: this.onClickPromotionButton_emailTemplate.bind(this),
      template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
    },

    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'

  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    }; 
    
    public simpleToolBar_emailTemplateEditorPrivate: object = {
      type: 'Expand',
      enableFloating: false,
      items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      {
        tooltipText: 'Insert Widget',
        undo: true,
        click: this.onClickPromotionButton_emailTemplatePrivate.bind(this),
        template: '<button type="button" class="btn btn-default btn-outline btn-md"><i class="fa fa-arrows-alt"></i> insert variables</button>'
      },
  
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo', '|', 'CreateTable'
  
    ],
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
      };    



  changes_made: any = 1;
  brand: any;
  brand_id: string;

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService,
      public toastr: HotToastService,
      private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard

  ) {
    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);
    this.doc_id = +this.route.snapshot.paramMap.get('doc_id');
   }

  ngOnInit() {
    // this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/'  + this.doc_id; // no trailing slash
    this.baseUploadURL = this.gfunc.baseUploadURL; // all templates reside in the same directory.
    this.baseUploadURLOriginalWordTemplates = this.gfunc.baseUploadURLOriginalWordTemplates;
    this.baseUploadURLEmailTemplates = this.gfunc.baseUploadURLEmailTemplates; // all templates reside in the same directory.
    this.baseUploadURLDocxThemeTemplates = this.gfunc.baseUploadURLDocxThemeTemplates;
   // this.model = new SubjectTemplateDocs(); only for create components
    this.getSubjectTemplateDoc(this.doc_id);
    this.getBrandTypes();
    this.getSubjectComTypes();
    this.getJobTypes();
    this.getSubjectAttemptTypes();
  }


  getSubjectTemplateDoc(doc_id) {
    this._demoService.getSubjectTemplateDoc(doc_id).subscribe(
      data => { this.subject_template_doc = data;
        const res = data[0];
        // load the drop downs
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        // this.getJobTypes();

      },
      err => console.error(err),
      () => console.log('')
    );
  }

// need to change this below
editDoc(model) {
  // model.job_id = this.job_id;
   this._demoService.updateSubjectTemplateDoc(model).subscribe(

    data => { // this.trace_candidate_update = data;
      // refresh the list
     // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
    this.toastr.success('Communication Template Updated Successfully');
  //  this.createJobSubjectsMultiple(model);
    // Subject to reload the manager component parent.
   // TraceCandidateManagerComponent.returned.next(false);
   // Refreshes itself
   this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
   .then(() => this.router.navigate(['admin/communication/com_type_template_doc_edit/' + model.doc_id]));

              return true;
    },
    // error => {
    //  // console.error('Error saving Event!');
    //   this.toastr.error('Error saving Document!');
    //   return Observable.throw(error);
    // },
    err => {
      this.toastr.error('Error Saving Updates to the Communication Template!');
      console.error(err)
    },
    () => console.log('done updates')
);
  }



 getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }

// Edit a Theme component.
editThemeFile(file_id, filename){
  this.router.navigate(['/admin/system-file-manager/system-doc-edit/theme-docx-edit/' + file_id + '/' + filename]);
};

     // to router navigate back
     public goBack() {
      this._location.back();
    }

    docView(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_view/' + doc_id + '']);
    }

    docEdit(doc_id) {
      this.router.navigate(['/admin/communication/com_type_template_doc_edit/' + doc_id + '']);
    }





   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Template Document',
      item_id: 1010,
      doc_id: this.doc_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadDocxTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Communication Template Document Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
                //     this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // console.log(value); // here you will get the value of the file
                //   // Remove the "uploads/" part from the filename.
                //   this.filenameselected = value;
                // // this.stripped = this.filenameselected.replace('uploads/', '');
                //   // this.model.main_image = this.stripped; // works for simple add not update.
                //   // console.log(this.stripped);
                //   // console.log(this.model);
                //   // this.form.logo = this.stripped;
                //   this.form.doc_template_file = this.filenameselected;
                //   // this.form.reset();
                //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   this.form.controls['doc_template_file'].patchValue(this.form.doc_template_file);

                //   });

                  this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// Angular 14 working.....

   }


		// :: Parent / Child modal test
		public addFileNameFromModal(filename) {
		  alert('Clicked');
		  this.form.controls['doc_template_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};




      // MODAL view a component
      openModalDotComponent() {
        const initialState = {
          title: 'Upload Template Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDotTemplateModalComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
              //     this.bsModalRef.content.action.take(1).subscribe((value: any) => {
              //   // console.log(value); // here you will get the value of the file
              //   // Remove the "uploads/" part from the filename.
              //   this.filenameselected = value;
              //  // this.stripped = this.filenameselected.replace('uploads/', '');
              //   // this.model.main_image = this.stripped; // works for simple add not update.
              //   // console.log(this.stripped);
              //   // console.log(this.model);
              //   // this.form.logo = this.stripped;
              //  // this.form.doc_template_file = this.filenameselected;
              //   this.form.original_doc_file = this.filenameselected;
              //   // this.form.reset();
              //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              //   this.form.controls['original_doc_file'].patchValue(this.form.original_doc_file);

              //   });

              this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ODF.bind(this)); /// Angular 14 working.....

       }


		// :: Parent / Child modal test
		public addFileNameFromModal_ODF(filename) {
		  alert('Clicked');
		  this.form.controls['original_doc_file'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};

       

   // MODAL view a component
   openModalEmailTemplates() {
    const initialState = {
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(UploadEmailTemplateModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.doc_id = this.doc_id;
    this.bsModalRef.content.item_id = this.doc_id;
    this.bsModalRef.content.title = 'Email Template Manager';
    this.bsModalRef.content.closeBtnName = 'Close';
   // this.bsModalRef.content.brand_model = this.subject_template_doc;
    // subscribed to the emitter and get the value.
        //     this.bsModalRef.content.action.take(1).subscribe((value) => {
        //   // console.log(value); // here you will get the value of the file
        //   // Remove the "uploads/" part from the filename.
        //   this.filenameselected = value;
        //  // this.stripped = this.filenameselected.replace('uploads/', '');
        //   // this.model.main_image = this.stripped; // works for simple add not update.
        //   // console.log(this.stripped);
        //   // console.log(this.model);
        //   // this.form.logo = this.stripped;
        //   this.form.email_template = this.filenameselected;
        //   // this.form.reset();
        //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
        //   this.form.controls['email_template'].patchValue(this.form.email_template);

        //   });
        this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_ET.bind(this)); /// Angular 14 working.....
   }



		// :: Parent / Child modal test
		public addFileNameFromModal_ET(filename) {
		  alert('Clicked');
		  this.form.controls['email_template'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};






   private getSubjectComTypes() {
    this._demoService.getSubjectComTypes()
      .subscribe(
        res => this.subject_com_types = res,
        err => console.error(err.status)
      );
  }



sendSubjectComTypeID(subject_com_type_id) {
// do nothing
  }



   // BOF SHARMANS CALLS
   getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....



   console.log('sending Count:' + this.count2);
  }


  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....



   console.log('sending Location:' + this.sent_job_type_location_id);
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....


   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }


  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }


 // get name for form.
 getJobTypeAllAffidavitType(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAllAffidavitType(job_type_affidavit_type_id)
    .subscribe(
      res => this.get_name = res,
      err => console.error(err.status)
    );
}
getSubjectTemplateDocsCheck(model) {
  // need to do a lookup to get name of doc....
 // this.getJobTypeAllAffidavitType(model.job_type_affidavit_type_id);
  // set the name
  // this.model.doc_name = this.get_name[0].job_type_affidavit_type_name;
   this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
      data => { this.doc_check = data;
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }


  docEditTemplateFile(doc_id) {
    this.router.navigate(['/admin/communication/template_doc_view/template/' + doc_id + '']);
  }



      // MODAL view a component
      openModalUploadDocxThemeTemplate() {
        const initialState = {
          title: 'Upload Docx Theme Document',
          item_id: 1010,
          doc_id: this.doc_id,
          size: 'lg',
          backdrop: true,
          IgnoreBackdropClick: false,
        };
        this.bsModalRef = this.modalService.show(UploadDocxThemeTemplateComponent, {initialState});
        // sets the var to in the component model
        this.bsModalRef.content.doc_id = this.doc_id;
        this.bsModalRef.content.item_id = this.doc_id;
        this.bsModalRef.content.title = 'Original Word Theme Files';
        this.bsModalRef.content.closeBtnName = 'Close';
       // this.bsModalRef.content.brand_model = this.subject_template_doc;
        // subscribed to the emitter and get the value.
                //     this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // console.log(value); // here you will get the value of the file
                //   // Remove the "uploads/" part from the filename.
                //   this.filenameselected = value;
                //  // this.stripped = this.filenameselected.replace('uploads/', '');
                //   // this.model.main_image = this.stripped; // works for simple add not update.
                //   // console.log(this.stripped);
                //   // console.log(this.model);
                //   // this.form.logo = this.stripped;
                //  // this.form.doc_template_file = this.filenameselected;
                //   this.form.document_base_theme_docx = this.filenameselected;
                //   // this.form.reset();
                //   // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   this.form.controls['document_base_theme_docx'].patchValue(this.form.document_base_theme_docx);

                //   });
                this.bsModalRef.content.action.subscribe(this.addFileNameFromModal_TD.bind(this)); /// Angular 14 working.....
       }

		// :: Parent / Child modal test
		public addFileNameFromModal_TD(filename) {
		  alert('Clicked');
		  this.form.controls['document_base_theme_docx'].patchValue(filename); // works by setting the new frorm value from parent modal.
      // has to be correct form name
		// this.modalRef.hide();
		// console.log('Added External Recipeint.');
		// this.toastr.info('External Recipient Added');
		};


    getSubjectAttemptType(subject_service_type_id) {
      this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
        data => { this.subjectAttemptType = data;
        let res = data[0]
        // this.subject_attempt_type_label = res.subject_attempt_type_name;
        },
        err => console.error(err),
      );
      }
    
    
     getSubjectAttemptTypes() {
      this._demoService.getSubjectAttemptTypes().subscribe(
        data => { this.subjectAttemptTypesList = data; },
        err => console.error(err),
      );
      }



// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
//  this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};


setColour(value2){
  console.log('SetColour: ' + value2)
  this.brandForm.log_type_colour.value = this.brandForm.colourpicker.value
}

clearColour(field, model){
  // this.brandForm.system_automation_colour.value = ''
  // model.system_automation_colour.value = '';
  // return model;
  this.form.controls['system_automation_colour'].patchValue(''); 
}

onChangePromtSave(any) {
  //  alert('you have made changes, please remember to save!');
  //  console.log('form changed');
   this.changes_made = null;
  }

  onChangePromtSaveHide() {
    //  alert('you have made changes, please remember to save!');
    //  console.log('form changed');
     this.changes_made = 1;
    }

      // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
}

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }

  copyToClipboard(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardPlainText(id) {
    const content = document.getElementById(id).innerText; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    // this.clipboard.copy(this.removeTags(content));
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }



    // BOF Image Modal - for rich text editor
    public onClickPromotionButton() {
      // this.rteObj.focusIn();
      this.openModalWithComponent_Promotion();
  }

  public onClickPromotionButton_defaultRTE() {
    // this.rteObj.focusIn();
    this.openModalWithComponent_Promotion();
}
  
public onClickPromotionButton_noteTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_noteTemplate();
}

public onClickPromotionButton_noteTemplatePrivate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_noteTemplatePrivate();
}

public onClickPromotionButton_emailTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailTemplate();
}  

public onClickPromotionButton_emailTemplatePrivate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailTemplatePrivate();
}  

public onClickPromotionButton_emailSubjectTemplate() {
  // this.rteObj.focusIn();
  this.openModalWithComponent_Promotion_emailSubjectTemplate();
}  

  
    // MODAL view a component
    openModalWithComponent_Promotion() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    
    this.bsModalRef.content.editorID = 'defaultRTE',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }


    // MODAL view a component
    openModalWithComponent_Promotion_noteTemplate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "noteTemplate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    this.bsModalRef.content.editorID = 'noteTemplate',
    
    // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              
              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }

  openModalWithComponent_Promotion_noteTemplatePrivate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "noteTemplatePrivate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    
    this.bsModalRef.content.editorID = 'noteTemplatePrivate',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name
             
              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              
              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }  

  openModalWithComponent_Promotion_emailTemplate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "emailTemplate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    this.bsModalRef.content.editorID = 'emailTemplate',
    
    // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server


              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }  

  openModalWithComponent_Promotion_emailTemplatePrivate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "emailTemplatePrivate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    this.bsModalRef.content.editorID = 'emailTemplatePrivate',
    
    // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              
              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.action.subscribe(this.insertImageFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              // this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server


              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }  

// testing for normal form file button.
  openModalWithComponent_Promotion_emailSubjectTemplate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "emailSubjectTemplate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    this.bsModalRef.content.editorID = 'emailSubjectTemplate',
    
    // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
            // For Email Subhect filds -- brand from


              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }  
  
  openModalWithComponent_Promotion_emailSubjectTemplatePrivate() {
    const initialState = {
      title: 'Select System Variable/Item(s) - Choose for Templates',
      item_id: 1010,
      brand_id: this.gfunc.sessionBrandId,
      promotion_id: '',
      template_model: null,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
      editorID: "emailSubjectTemplatePrivate"
    };
    this.bsModalRef = this.modalService.show(WooPromotionVariableModalComponent, {initialState});
    // sets the var to in the component model
    
    this.bsModalRef.content.editorID = 'emailSubjectTemplatePrivate',
    
    // this.bsModalRef.content.editorID = 'EditdasfDIIIIIIIIIFARK',
  

    this.bsModalRef.content.brand_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.item_id = this.gfunc.sessionBrandId,
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // this.bsModalRef.content.promotion_id = this.promotion_id;
    this.bsModalRef.content.template_model = this.subject_template_doc; // model of the template form
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
          
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked..... --- dont need this but this is for adding the actual fileID and name

              this.bsModalRef.content.action.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionVariable.subscribe(this.insertVariableFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImage.subscribe(this.insertImageFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionStr.subscribe(this.insertStrFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              this.bsModalRef.content.actionImageQR.subscribe(this.insertImageQRFromModal.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server

              this.bsModalRef.content.actionVariable_EditorID.subscribe(this.insertVariableFromModal_EditorID.bind(this)); /// for inserting an image URL directly into the RichTextEditor - direct file on server
              
            // For Email Subhect filds -- brand from


              // Try wrapping an image tag around the image before inserting.
              // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

              // return this.modalRef.content.onClose;

  }    


     // this willl have to be avariable.
          // :: Parent / Child modal test
          public insertPromotionFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                    let insert_tag = 'NOT USED -- {{' + fileurl + '}}'
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
           

           
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
    
    
          public insertStrFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                    let insert_tag = '' + fileurl + ''
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
    
    
          public insertVariableFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
                    // auto inserts the variable name of theat which was sent.
                  //  pps
                    // let insert_tag = '${' + fileurl + '}'
  
                    // sharmans
                    let insert_tag = fileurl;
  
  
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
            // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.

  
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };
  
  
  
  
          public insertImageQRFromModal(fileurl) {
            // alert('Clicked Insert');
      
      
                    // Try wrapping an image tag around the image before inserting.
                    // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
      
                    // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
  
                                    // april 28 2023 - now in assets of brand.
                  let link = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id + '/qrcodes/' + fileurl;
                  let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="'+ link + '" >'
    
                    // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src=" https://ppsdistrohub.nickbowen.com.au/APP_PHP/uploads/' + fileurl + '" >'
      
            // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
      
      
            // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 
      
      
            // insertImage(fileurl);
      
            // has to be correct form name
          // this.modalRef.hide();
          // console.log('Added External Recipeint.');
          // this.toastr.info('External Recipient Added');
          };




  // :: Parent / Child modal test
  public insertImageFromModal(fileurl) {
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'

    // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(fileurl));
    InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    // InsertHtml.Insert(document, document.createElement('image') )


    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };



  // Now workes for multiple editors on a page... few!! 11pm 2/12/23
  public insertVariableFromModal_EditorID(fileurl) {
    // alert('Clicked Insert');

    console.log(JSON.stringify(fileurl))
    let editorID = fileurl.editorID
    let insert_variable = fileurl.fileurl

    this.toastr.info('Variable Inserted: ' + insert_variable)

    // this.toastr.info('editorID: ' + editorID)

            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">
            // auto inserts the variable name of theat which was sent.
          //  pps
            // let insert_tag = '${' + fileurl + '}'

            // sharmans
    // let insert_tag = fileurl;
    // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI


        // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
        // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
        // // InsertHtml.Insert(document, document.createTextNode(fileurl));
        // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
        // // InsertHtml.Insert(document, document.createElement('image') )

        // // Need an if statment and to get the Editor ID , to have muliple occurannces on one page.

      
    if (editorID == 'emailSubjectTemplate'){  
      // Now adds to the subject
      let currentValue =   this.form.controls['email_subject_primary'].value;
      let newValue = '';
      if(currentValue == null){
        newValue = insert_variable;
      }else{
        newValue = currentValue + ' ' + insert_variable;
      }
      this.form.controls['email_subject_primary'].patchValue(newValue);
    }

    if (editorID == 'emailSubjectTemplatePrivate'){  
      // Now adds to the subject
      let currentValue =   this.form.controls['email_subject_private'].value;
      let newValue = '';
      if(currentValue == null){
        newValue = insert_variable;
      }else{
        newValue = currentValue + ' ' + insert_variable;
      }
      this.form.controls['email_subject_private'].patchValue(newValue);
    }

        
  if (editorID == 'emailTemplate'){
    this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
    } 
    
    if (editorID == 'emailTemplatePrivate'){
      this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
      InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
      }    

        // NoteTemplate Editor.
   if (editorID == 'noteTemplate'){
    this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
   }

        // NoteTemplate Editor.
        if (editorID == 'noteTemplatePrivate'){
          this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
          InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
         }
      

   if (editorID == 'defaultRTE'){
    this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
    InsertHtml.Insert(document, document.createTextNode(insert_variable)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
   }
    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };

// Now works to insert uploaded images directly from the tabs for -- blocked for Email Subject
  public insertImageFromModal_EditorID(fileurl) {
   
    // Need to create the new button in HTML widget to click.
    console.log(JSON.stringify(fileurl))
    let editorID = fileurl.editorID
    let insert_variable = fileurl.fileurl
   
    // alert('Clicked Insert');


            // Try wrapping an image tag around the image before inserting.
            // <img src="img_girl.jpg" alt="Girl in a jacket" width="500" height="600">

            // let insert_tag = '<img class="e-rte-image e-imginline e-img-focus" src="' + fileurl + '" >'
            let insert_tag = '<img class="e-rte-image e-imginline e-img-focus"  src="' + insert_variable + '" >'


            if (editorID == 'defaultRTE'){
                          // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
            this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
            // InsertHtml.Insert(document, document.createTextNode(fileurl));
            InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
            // InsertHtml.Insert(document, document.createElement('image') )
             }
          
             if (editorID == 'emailSignatureTemplate'){
              this.emailSignatureTemplate.focusIn(); // these two lines work for RichTextEditor
              InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
             }


             // Ugraded for communications to accept images

              if (editorID == 'emailTemplate'){
                this.emailTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI

              } 

              if (editorID == 'emailTemplatePrivate'){
                this.emailTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI

              }    

              // NoteTemplate Editor.
              if (editorID == 'noteTemplate'){
                this.noteTemplateEditor.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI

              }

              // NoteTemplate Editor.
              if (editorID == 'noteTemplatePrivate'){
                this.noteTemplateEditorPrivate.focusIn(); // these two lines work for RichTextEditor
                InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
              }






                  // // this.form.controls['doc_template_file'].patchValue(fileurl); // works by setting the new frorm value from parent modal.
                  // this.defaultRTE.focusIn(); // these two lines work for RichTextEditor
                  // // InsertHtml.Insert(document, document.createTextNode(fileurl));
                  // InsertHtml.Insert(document, document.createTextNode(insert_tag)); // This worked with Editor mode as HTML / and remove sanitisation on the UI
                  // // InsertHtml.Insert(document, document.createElement('image') )



    

    // class="e-rte-image e-imginline e-img-focus" alt="pps_beta_logo.png" width="auto" height="auto" 


    // insertImage(fileurl);

    // has to be correct form name
  // this.modalRef.hide();
  // console.log('Added External Recipeint.');
  // this.toastr.info('External Recipient Added');
  };



    // END OF IMAGE modal 



}
